import { Link } from "react-router-dom";
import { Logo } from "@/components/common/Logo";

export default function MarketingHeader() {
  return (
    <header data-testid="marketing-header" className="sticky top-0 z-40 border-b border-[#E4E9EF] bg-white/80 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6">
        <Logo />
        <nav className="hidden items-center gap-8 md:flex" aria-label="Primary">
          <a href="/#features" className="hs-nav-link text-sm">Features</a>
          <a href="/#pricing" className="hs-nav-link text-sm">Pricing</a>
          <Link to="/setup-guide" data-testid="header-setup-guide" className="hs-nav-link text-sm">Setup guide</Link>
        </nav>
        <div className="flex items-center gap-3">
          <Link to="/login" data-testid="header-signin" className="hs-btn-ghost text-sm">Sign in</Link>
          <Link to="/signup" data-testid="header-cta" className="hs-btn-primary text-sm">Start free trial</Link>
        </div>
      </div>
    </header>
  );
}
